import './helpers/_detectTouch';
import './libs/simplyCountdown';
import './modules/lazy';
import popupsInit from './_popup';
import citiesChoice from './modules/_cities';
import countDown from './modules/_countdown';
import initMask from './modules/_initMask';
import Modal from './modules/_modal';
import toTop from './modules/_scrollTop';
import sidebarToggle from './modules/_sidebarToggle';
import simpleModal from './modules/_simple-modal';
import tabsInit from './modules/_tabs';
import initTooltips from './modules/_tooltip';
import accordion from './modules/_accordion';
import scrollTo from './modules/scrollTo';
import runPolyfills from './polyfills';
import burgerMenu from './_burger-menu';
import customSelect from './modules/_custom-select';
import filtersFn from './modules/_filters';
import toggler from './modules/_toggler';
import productsSlider from './sliders/_products';
import searchPopupInit from './modules/_search-popup';
import Validation from './modules/_validator';
import numInputInit from './modules/_numInput';
import initCartModal from './modules/_cart';
import alignProduct from './modules/_alignProduct';

document.addEventListener('DOMContentLoaded', () => {
  sidebarToggle();
  popupsInit();
  tabsInit();
  filtersFn();
  accordion();
  customSelect();
  runPolyfills();
  burgerMenu();
  toTop();
  toggler();
  citiesChoice();
  initTooltips();
  scrollTo();
  countDown();
  initMask();
  simpleModal();
  searchPopupInit();
  numInputInit();
  initCartModal();
  alignProduct();

  const productsSliderElems = Array.prototype.slice.call(document.querySelectorAll('.js-products-slider-wrapper'));

  if (productsSliderElems.length) {
    productsSliderElems.forEach((el) => {
      productsSlider(el);
    });
  }

  const $togglePass = $('.js-toggle-pass');
  if ($togglePass.length) {
    $togglePass.on('click', (e) => {
      const $input = $(e.currentTarget).parent().find('input');
      const type = $input.attr('type');

      if (type === "password") {
        $input.prop('type', 'text');
      } else {
        $input.prop('type', 'password');
      }
      $(e.currentTarget).toggleClass('is-active');
    });
  }

  window.modal = new Modal();
  window.modal.init();

  window.validation = new Validation();

  // function openCouponsModal(selector = null, timeout = 2000) {
  //   const el = document.querySelector(selector);
  //   if (el) {
  //     setTimeout(() => {
  //       window.modal.open(el, false);
  //     }, timeout);
  //   }
  // }
  // openCouponsModal('[data-modal="coupons-popup"]', 2000)

  // temp: open cart popup
  // const cm = document.querySelector('[data-modal="cart-modal"]');
  // if (cm) window.modal.open(cm, false);

  $(document).mouseup((e) => {
    const $container = $('.js-click-outside');
    if ($container.has(e.target).length === 0) {
      $container.hide();
    }
  });
});
